import type { GetV1ScenariosNodesDefinitions200, GetV1ScenariosNodesDefinitionsQueryResponse } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { nodeDefinitionSchema } from './nodeDefinitionSchema'
import { z } from 'zod'

/**
 * @description The list of node definitions
 */
export const getV1ScenariosNodesDefinitions200Schema = z.array(z.lazy(() => nodeDefinitionSchema)) as unknown as ToZod<GetV1ScenariosNodesDefinitions200>

export type GetV1ScenariosNodesDefinitions200Schema = GetV1ScenariosNodesDefinitions200

export const getV1ScenariosNodesDefinitionsQueryResponseSchema = z.lazy(
  () => getV1ScenariosNodesDefinitions200Schema,
) as unknown as ToZod<GetV1ScenariosNodesDefinitionsQueryResponse>

export type GetV1ScenariosNodesDefinitionsQueryResponseSchema = GetV1ScenariosNodesDefinitionsQueryResponse